import { render } from "./InvoiceMetrics.vue?vue&type=template&id=66ef016c"
import script from "./InvoiceMetrics.vue?vue&type=script&lang=js"
export * from "./InvoiceMetrics.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__